import React from 'react';

// Components
import VerticalLayout from './VerticalLayout';
import Topbar from './topbar';
import { Box } from '@mui/material';
import ImpersonationBanner from '../pages/admin/tenants/ImpersonationBanner';

const index = (props: any) => {
    return (
        <React.Fragment>
            <ImpersonationBanner />
            <Topbar />
            <VerticalLayout>
                <Box>
                    {props.children}
                </Box>
            </VerticalLayout>
        </React.Fragment>
    );
};

export default index;